export const PROJECT_STATUSES = ['not_started', 'active', 'on_hold', 'completed', 'cancelled'];
export const TASK_STATUSES = ['todo', 'in_progress', 'blocked', 'done', 'cancelled'];
export const BOARD_COLUMNS = ['todo', 'in_progress', 'blocked', 'done'];
export const PRIORITIES = ['low', 'medium', 'high', 'urgent'];

export const STATUS_LABEL = {
  not_started: 'Not started', active: 'Active', on_hold: 'On hold',
  completed: 'Completed', cancelled: 'Cancelled',
  todo: 'To do', in_progress: 'In progress', blocked: 'Blocked', done: 'Done',
};
export const STATUS_COLOUR = {
  not_started: '#6c757d', active: '#599BE3', on_hold: '#f0a500',
  completed: '#91CF9B', cancelled: '#adb5bd',
  todo: '#6c757d', in_progress: '#599BE3', blocked: '#ffc107', done: '#91CF9B',
};
export const PRIORITY_COLOUR = { low: '#6c757d', medium: '#599BE3', high: '#f0a500', urgent: '#dc3545' };

// Extract a safe display string from an axios error. FastAPI 422 responses put an
// array of objects in `detail`, which would crash React if rendered directly.
export const errMsg = (err, fallback = 'Something went wrong') => {
  const d = err?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((e) => (e && e.msg) || JSON.stringify(e)).join('; ');
  if (d && typeof d === 'object') return JSON.stringify(d);
  return err?.message || fallback;
};

